import { Model as R } from "../../../model.js";
var d = /* @__PURE__ */ ((E) => (E[E.FIXED_DISCOUNT = 1] = "FIXED_DISCOUNT", E[E.PERCENT_DISCOUNT = 2] = "PERCENT_DISCOUNT", E[E.FREE_ITEM = 3] = "FREE_ITEM", E[E.FREE_DELIVERY = 4] = "FREE_DELIVERY", E[E.OTHERS = 5] = "OTHERS", E))(d || {});
class D extends R {
  constructor(s) {
    super(), this.generatedId = s.generatedId, this.code = s.code, this.value = s.value, this.name = s.name, this.promotionType = s.promotionType;
  }
}
export {
  D as TicketItemPromotionModel,
  d as TicketItemPromotionType
};
//# sourceMappingURL=ticketItemPromotion.model.js.map
